export enum MaintenanceStatus {
    ACTIVE = 0,
    AUTOMATIC = 1,
    MAINTENANCE = 2,
    IN_PROGRESS = 3,
    RESTARTING = 4,
    VERIFYING = 5,
    ERROR = 6
  }